export default {
  functional: true,
  render(h, { props, listeners, children }) {
    const { disabled, checked, iconClass } = props

    const icon = h('i', { class: ['icon-link-icon', ...iconClass] })
    const text = h('span', { class: ['icon-link-text'] }, children)

    const tagName = disabled ? 'div' : 'button'

    const data = {
      class: {
        'icon-link': true,
        'is-disabled': disabled,
        'is-checked': checked
      },
    }

    // クリックイベントの受け渡し
    if (typeof listeners.click !== 'undefined' && !disabled) {
      data.on = {
        click: listeners.click
      }
    }

    return h(tagName, data, [icon, text])
  }
}
